"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserController = void 0;
var neko_1 = require("../../services/neko");
var Result_1 = __importDefault(require("../../Result"));
var errors_1 = require("./errors");
var errors_2 = require("../AuthController/errors");
/**
 * All things user
 */
var UserController = /** @class */ (function () {
    function UserController() {
    }
    /**
     * Gets user details
     */
    UserController.getUserDetails = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.user.details()];
                    case 1:
                        data = _a.sent();
                        if (!data)
                            return [2 /*return*/, Result_1.default.fail(errors_1.NO_USER_DETAILS)];
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.NO_USER_DETAILS)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets user's general notifications preferences
     */
    UserController.getGeneralNotifications = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.user.getGeneralNotifications()];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.NO_GENERAL_NOTIFICATIONS)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates user's general notifications preferences
     */
    UserController.updateGeneralNotifications = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.user.updateGenerallNotifications(body)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_3 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_UPDATE_GENERAL_NOTIFICATIONS)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets users price notifications preferences
     */
    UserController.getPricingNotifications = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.user.getPricingNotifications()];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_4 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.NO_PRICING_NOTIFICATIONS)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates user's price notifications preferences
     */
    UserController.updatePricingNotifications = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.user.updatePricingNotifications(body)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_5 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_UPDATE_PRICING_NOTIFICATIONS)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Delete user's price notifications preferences
     */
    UserController.deletePricingNotifications = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.user.deletePricingNotifications(body)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_6 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_DELETE_PRICING_NOTIFICATIONS)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get user's preferences
     */
    UserController.getUserPreferences = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.user.getUserPreferences()];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_7 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.NO_USER_PREFERENCES)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update user's currency preferences
     */
    UserController.updateCurrency = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.user.updateCurrency(body)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_8 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_UPDATE_USER_PREFERENCES_CURRENCY)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update user's chain priority preference
     */
    UserController.updateChainPriority = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.user.updateChainPriority(body)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_9 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_UPDATE_USER_PREFERENCES_CHAIN_PRIORITY)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update user's chain properties preference
     */
    UserController.updateChainProperties = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.user.updateChainProperties(body)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_10 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_UPDATE_USER_PREFERENCES_CHAIN_PROPERTIES)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update user's wallet order preference
     */
    UserController.updateWalletOrder = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.user.updateWalletOrder(body)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_11 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_UPDATE_USER_PREFERENCES_WALLET_ORDER)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    UserController.getElementSettings = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.user.getElementSettings()];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_12 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.NO_ELEMENT_SETTINGS)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    UserController.getElementSetting = function (elementId) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.user.getElementSetting(elementId)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_13 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.NO_ELEMENT_SETTING)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    UserController.updateElementSetting = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.user.updateElementSetting(body)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_14 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.UNABLE_TO_UPDATE_USER_PREFERENCES_ELEMENT_SETTING)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    UserController.createUserWithEmail = function (userDetails) {
        return __awaiter(this, void 0, void 0, function () {
            var userData, error_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.user.createUserEmail(userDetails)];
                    case 1:
                        userData = _a.sent();
                        if (!userData)
                            throw Error(errors_2.NOT_AUTHORIZED);
                        return [2 /*return*/, Result_1.default.ok(userData)];
                    case 2:
                        error_15 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(error_15.message)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    UserController.createUserWithProvider = function (userDetails) {
        return __awaiter(this, void 0, void 0, function () {
            var userData, error_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.user.createUserProvider(userDetails)];
                    case 1:
                        userData = _a.sent();
                        if (!userData)
                            throw Error(errors_2.NOT_AUTHORIZED);
                        return [2 /*return*/, Result_1.default.ok(userData)];
                    case 2:
                        error_16 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(error_16.message)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    UserController.getUserDetailsV2 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_17;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.user.userDetails()];
                    case 1:
                        data = _a.sent();
                        if (!data)
                            return [2 /*return*/, Result_1.default.fail(errors_1.NO_USER_DETAILS)];
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_17 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.NO_USER_DETAILS)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return UserController;
}());
exports.UserController = UserController;
